import styled from '@emotion/styled'
import { themeColor, themeFont } from 'mixins'
import { IDetailsGroupDividerProps } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1em 1.5em 1em 1.5em;
  background: ${themeColor('neutralLight')};
  border-bottom: 1px solid ${themeColor('neutralTertiary')};
`
const Title = styled.div`
  ${themeFont('large')};
  font-weight: 600;
  cursor: pointer;
`
const Actions = styled.div`
  margin: -8px 0;
`

export type GroupHeaderProps = IDetailsGroupDividerProps & {
  // onNavigateGroup: (group: IGroup) => void
  // onAcceptAllGroupChanges: (group: IGroup) => void
  // onRejectAllGroupChanges: (group: IGroup) => void
}
export const GroupHeader: React.FC<GroupHeaderProps> = ({
  group,
  // onAcceptAllGroupChanges,
  // onRejectAllGroupChanges,
  // onNavigateGroup,
  onToggleCollapse,
}) => {
  const { t } = useTranslation()
  // const theme = useTheme()

  return group ? (
    <Container>
      <Title onClick={() => onToggleCollapse!(group)}>
        <span>
          {t(`section.${group!.name}.header`, {
            defaultValue: group!.name,
          })}
        </span>
        &nbsp;
        <span>({group!.count})</span>
      </Title>
      {!group.isCollapsed && (
        <Actions>
          {/* <ActionButton
            onClick={() => onAcceptAllGroupChanges(group!)}
            iconProps={{
              iconName: 'CheckMark',
              style: { color: theme.palette.green },
            }}
          >
            {t('action.acceptAll')}
          </ActionButton>
          <ActionButton
            onClick={() => onRejectAllGroupChanges(group!)}
            iconProps={{
              iconName: 'Cancel',
              style: { color: theme.palette.red },
            }}
          >
            {t('action.rejectAll')}
          </ActionButton> */}
          {/* <ActionButton
            onClick={() => onNavigateGroup(group!)}
            iconProps={{
              iconName: 'PageList',
              style: { color: theme.palette.neutralPrimary },
            }}
          >
            {t('action.gotoList')}
          </ActionButton> */}
        </Actions>
      )}
    </Container>
  ) : null
}
